var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "jquery"], function (require, exports, jquery_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.T = exports.CleaveDateFormat = exports.FlatpickrDateFormat = exports.Locale = exports.Culture = void 0;
    jquery_1 = __importDefault(jquery_1);
    function Culture() {
        return (0, jquery_1.default)("#currentCulture").val();
    }
    exports.Culture = Culture;
    // es 2 premiers lettres de la culture
    function Locale() {
        var currentCulture = Culture();
        var currentLocale = "fr";
        if (currentCulture && currentCulture.length) {
            currentLocale = currentCulture.substring(0, 2);
        }
        return currentLocale;
    }
    exports.Locale = Locale;
    // https://en.wikipedia.org/wiki/Date_format_by_country
    // https://flatpickr.js.org/formatting/
    function FlatpickrDateFormat() {
        switch (Locale()) {
            case "fr": return "d/m/Y"; // dd/mm/yyyy
            case "it": return "d/m/Y"; // dd/mm/yyyy
            case "en": return "m/d/Y"; // mm/dd/yyyy
            case "nl": return "d-m-Y"; // dd-mm-yyyy
        }
        // fr par default
        return "d/m/Y"; // dd/mm/yyyy
    }
    exports.FlatpickrDateFormat = FlatpickrDateFormat;
    // https://en.wikipedia.org/wiki/Date_format_by_country
    // https://github.com/nosir/cleave.js/blob/master/doc/options.md#datepattern
    // https://github.com/nosir/cleave.js/blob/master/doc/options.md#delimiter
    function CleaveDateFormat() {
        switch (Locale()) {
            case "fr": return { datePattern: ['d', 'm', 'Y'], delimiter: '/' }; // dd/mm/yyyy
            case "it": return { datePattern: ['d', 'm', 'Y'], delimiter: '/' }; // dd/mm/yyyy
            case "en": return { datePattern: ['m', 'd', 'Y'], delimiter: '/' }; // mm/dd/yyyy
            case "nl": return { datePattern: ['d', 'm', 'Y'], delimiter: '-' }; // dd-mm-yyyy
        }
        // fr par default
        return { datePattern: ['d', 'm', 'Y'], delimiter: '/' }; // dd/mm/yyyy
    }
    exports.CleaveDateFormat = CleaveDateFormat;
    var i18nTranslations = null;
    function T(key) {
        if (i18nTranslations == null) {
            var $i18nData = (0, jquery_1.default)("#i18nData");
            if ($i18nData.length > 0) {
                i18nTranslations = JSON.parse($i18nData.val());
            }
            else {
                i18nTranslations = {};
            }
        }
        return i18nTranslations[key];
    }
    exports.T = T;
});
//# sourceMappingURL=i18n-ts.js.map